import { ApiHistory } from 'services/api/history/types';
import { keysToCamel } from 'utils/utils';

import { History } from '../../types';

export const aiWriterHistoryFromApi = (history: ApiHistory): History =>
  keysToCamel(history) as History;
